import React, { useState, useContext } from "react"
import SEO from "../components/seo"
import Card from "@material-ui/core/Card"
import CardActions from "@material-ui/core/CardActions"
import CardContent from "@material-ui/core/CardContent"
import CardHeader from "@material-ui/core/CardHeader"
import TextField from "@material-ui/core/TextField"
import Button from "@material-ui/core/Button"
import { FirebaseContext } from "../components/firebase"
import { navigate } from "gatsby"
import Alert from "@material-ui/lab/Alert"
import Grid from "@material-ui/core/Grid"

const rowStyle = {
  marginBottom: "15px",
}

const RegisterPage = () => {
  const { firebase } = useContext(FirebaseContext)

  const [errorMessage, setErrorMessage] = useState(null)
  const [formValues, setFormValues] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
  })

  const handleInputChange = e => {
    e.persist()
    setErrorMessage(null)
    setFormValues(currentValues => ({
      ...currentValues,
      [e.target.name]: e.target.value,
    }))
  }

  const handleFormSubmit = e => {
    e.preventDefault()

    if (formValues.password === formValues.confirmPassword) {
      firebase
        .register({
          name: formValues.name,
          email: formValues.email,
          password: formValues.password,
        })
        .then(() => navigate("/games"))
        .catch(error => setErrorMessage(error.message))
    } else {
      setErrorMessage("Password and Confirm Password do not match.")
    }
  }

  return (
    <section>
      <SEO title="Register" />
      <Grid container justify="center" alignContent="center">
        <Grid item xs={12} sm={6}>
          <Card
            style={{
              padding: "1em",
            }}
            elevation={2}
          >
            <CardHeader title="Register for New Account" />
            <form onSubmit={handleFormSubmit}>
              <CardContent>
                <div style={rowStyle}>
                  <TextField
                    name="name"
                    onChange={handleInputChange}
                    value={formValues.name}
                    label="Name"
                    variant="outlined"
                    fullWidth
                    required
                  />
                </div>
                <div style={rowStyle}>
                  <TextField
                    name="email"
                    onChange={handleInputChange}
                    value={formValues.email}
                    label="Email"
                    type="email"
                    variant="outlined"
                    fullWidth
                    required
                  />
                </div>
                <div style={rowStyle}>
                  <TextField
                    name="password"
                    onChange={handleInputChange}
                    value={formValues.password}
                    type="password"
                    label="Password"
                    variant="outlined"
                    minLength={6}
                    fullWidth
                    required
                  />
                </div>
                <div style={rowStyle}>
                  <TextField
                    name="confirmPassword"
                    onChange={handleInputChange}
                    value={formValues.ConfirmPassword}
                    type="password"
                    label="Confirm Password"
                    variant="outlined"
                    minLength={6}
                    fullWidth
                    required
                  />
                </div>
                {errorMessage ? (
                  <Alert severity="error">{errorMessage}</Alert>
                ) : null}
              </CardContent>
              <CardActions>
                <Button
                  variant="contained"
                  style={{ backgroundColor: "var(--green)", color: "white" }}
                  type="submit"
                  fullWidth
                  disableElevation
                >
                  Register Account
                </Button>
              </CardActions>
            </form>
          </Card>
        </Grid>
      </Grid>
    </section>
  )
}

export default RegisterPage
